// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__82Kn9","active":"ProgressBar_active__SP6Ng","completed":"ProgressBar_completed__V8J81"};